// Library methods

// Utils
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_GET_ALL_ROLES,
    API_CREATE_ROLE,
    API_UPDATE_ROLE,
    API_GET_ALL_RESOURCE_PERMISSION_DETAILS,
    API_GET_ALL_ROLE_MAKERS,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import { SUCCESS_MESSAGES } from '../../../utils/constants/toastMessages';
import * as roleManagementActions from './roleManagement.actions';

// Constants
import {
    FETCH_ROLES_REQUEST,
    CREATE_ROLE_REQUEST,
    UPDATE_ROLE_REQUEST,
    FETCH_ALL_RESOURCE_PERMISSIONS_REQUEST,
    FETCH_ROLE_MAKERS_REQUEST,
} from './roleManagement.constants';
import { toast } from 'react-toastify';
import { takeLatest, put, call } from 'redux-saga/effects';
import moment from 'moment';

// Toast Messages

const getRequestData = payload => {
    const request = {
        page: payload.pageIndex || 1,
        resultPerPage: payload.pageSize || 10,
        roleFilter: {},
    };
    if (payload.createdOn) {
        request.roleFilter.createdStartDate = moment(
            payload.createdOn.startDate
        ).startOf('day');
        request.roleFilter.createdEndDate = moment(
            payload.createdOn.endDate
        ).endOf('day');
    }
    if (payload.createdBy) {
        request.roleFilter.roleCreatedBy = payload.createdBy;
    }
    if (payload.status) {
        request.roleFilter.roleStatus = payload.status;
    }
    return request;
};

export function* fetchAllRoles(actions) {
    yield put(roleManagementActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestData(payload);
        const { data } = yield call(POST, API_GET_ALL_ROLES, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(roleManagementActions.fetchRolesSuccess(data));
        } else if (data.statusCode === apiStatusCodes.NORECORD) {
            yield put(
                roleManagementActions.fetchRolesError({
                    error: {},
                })
            );
        } else if (data && data.errorMessage) {
            yield put(
                roleManagementActions.fetchRolesError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(roleManagementActions.fetchRolesError({ error: data }));
    }
    yield put(roleManagementActions.hideLoader());
}

export function* fetchRolesMakers(actions) {
    yield put(roleManagementActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_GET_ALL_ROLE_MAKERS, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(roleManagementActions.getMakersDetailsSuccess(data));
        } else if (data.statusCode === apiStatusCodes.NORECORD) {
            yield put(
                roleManagementActions.getMakersDetailsError({
                    error: {},
                })
            );
        } else if (data && data.errorMessage) {
            yield put(
                roleManagementActions.getMakersDetailsError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(roleManagementActions.getMakersDetailsError({ error: data }));
    }
    yield put(roleManagementActions.hideLoader());
}

export function* createRole(actions) {
    try {
        const { payload } = actions;
        const request = { ...payload };
        const { data } = yield call(POST, API_CREATE_ROLE, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                roleManagementActions.createRoleSuccess({
                    isLoading: false,
                    data,
                    message: '',
                })
            );
            toast.info(SUCCESS_MESSAGES.CREATE_ROLE);
        } else if (data && data.errorMessage) {
            yield put(
                roleManagementActions.createRoleError({
                    isLoading: false,
                    message: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data, status } = response;

        if (status !== 401) {
            yield put(
                roleManagementActions.createRoleError({
                    isLoading: false,
                    message: data.errorMessage,
                })
            );
        }
    }
}

export function* updateRole(actions) {
    try {
        const { payload } = actions;
        const request = { ...payload };
        const { data } = yield call(POST, API_UPDATE_ROLE, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                roleManagementActions.updateRoleSuccess({
                    isLoading: false,
                    data,
                    message: '',
                })
            );
            toast.info(SUCCESS_MESSAGES.UPDATE_ROLE);
        } else if (data && data.errorMessage) {
            yield put(
                roleManagementActions.updateRoleError({
                    isLoading: false,
                    message: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data, status } = response;

        if (status !== 401) {
            yield put(
                roleManagementActions.updateRoleError({
                    isLoading: false,
                    message: data.errorMessage,
                })
            );
        }
    }
}

export function* getAllResoursePermissions() {
    try {
        const request = {};
        const { data } = yield call(
            POST,
            API_GET_ALL_RESOURCE_PERMISSION_DETAILS,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                roleManagementActions.getAllResourcePermissionsSuccess(data)
            );
        } else if (data && data.errorMessage) {
            yield put(
                roleManagementActions.getAllResourcePermissionsError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data && data.errorMessage ? data.errorMessage : '';
        yield put(
            roleManagementActions.getAllResourcePermissionsError({
                error: errorMessage,
            })
        );
    }
}

/**
 * WATCHER SAGA
 */
export function* roleManagementSaga() {
    yield takeLatest(FETCH_ROLES_REQUEST, fetchAllRoles);
    yield takeLatest(CREATE_ROLE_REQUEST, createRole);
    yield takeLatest(UPDATE_ROLE_REQUEST, updateRole);
    yield takeLatest(
        FETCH_ALL_RESOURCE_PERMISSIONS_REQUEST,
        getAllResoursePermissions
    );
    yield takeLatest(FETCH_ROLE_MAKERS_REQUEST, fetchRolesMakers);
}
